<template>
    <div class="o-pager">
        <div class="o-pager__wrap">
            <button v-if="$root.totalPages>1" class="o-pager__btn o-pager__prev" :class="{'is-disable':$root.page===1}" @click="$root.page = $root.page > 1 ? $root.page-1:1">
                <svgIco icon="arrow-left" />
            </button>
            <template v-for="i in $root.pages" :key="i" >
                <button v-if="pageToShow(i)" class="o-pager__page" :class="{'is-active':$root.page==i }" @click="$root.page=i">{{ i }}</button>
                <span v-else-if="!pageToShow(i) && i==2 || !pageToShow(i) && i == $root.totalPages-1">...</span>

            </template>
            <button v-if="$root.totalPages>1" class="o-pager__btn o-pager__next" :class="{'is-disable':$root.page==$root.totalPages}" @click="$root.page = $root.page < $root.totalPages ? $root.page+1:$root.totalPages">
                <svgIco icon="arrow-right" />
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Pager',
    
    data() {
        return {
           
        }
    },
    computed: {
        
    },
    methods: {
        pageToShow(p) {
            if (p == 1 || p == this.$root.totalPages) {
                return true;
            }
            if (p >= this.$root.page - 5 && p <= this.$root.page + 5) {
                return true;
            }
            return false;
        }
        
    }
}
</script>

